module.exports = __webpack_public_path__ + "static/img/banner-2.82739e6c.jpg";